import { useMutation } from '@apollo/client';
import { EquipmentCreateInput, EquipmentUpdateInput } from '__generated__/graphql';
import { CREATE_EQUIPMENT, UPDATE_EQUIPMENT } from 'apollo/mutations/equipment-mutations';
import { getNowIsoAtUtcWithLocalTimeZone } from 'utils/dateUtils';
import { toOptionalNumber } from 'utils/numberUtils';
import { uuid } from 'utils/uuidUtils';
import useActiveMember from '../../store/useActiveMember';

export default function useEquipment() {
  const [createEquipmentMutation] = useMutation(CREATE_EQUIPMENT);
  const [editEquipmentMutation] = useMutation(UPDATE_EQUIPMENT);
  const activeMember = useActiveMember();

  function createEquipment(
    equipmentName: string,
    equipmentModelId: string,
    trackManualHours: boolean,
    year?: number,
    customField1?: string | null,
    customField2?: string | null,
    customField3?: string | null,
    customField4?: string | null,
    customField5?: string | null
  ) {
    const entry: EquipmentCreateInput = {
      id: uuid(),
      organizationId: activeMember.organizationId!,
      equipmentName,
      equipmentModelId,
      trackManualHours,
      year: toOptionalNumber(year),
      createdOn: getNowIsoAtUtcWithLocalTimeZone(),
      customField1,
      customField2,
      customField3,
      customField4,
      customField5,
    };

    return createEquipmentMutation({ variables: { equipment: entry } });
  }

  function editEquipment(
    equipmentId: string,
    equipmentName: string,
    equipmentModelId: string,
    trackManualHours: boolean,
    year?: number,
    customField1?: string | null,
    customField2?: string | null,
    customField3?: string | null,
    customField4?: string | null,
    customField5?: string | null
  ) {
    const entry: EquipmentUpdateInput = {
      id: equipmentId,
      equipmentName,
      equipmentModelId,
      trackManualHours,
      year: toOptionalNumber(year),
      customField1,
      customField2,
      customField3,
      customField4,
      customField5,
    };

    return editEquipmentMutation({ variables: { equipment: entry } });
  }

  function deleteEquipment(equipmentId: string) {
    const entry: EquipmentUpdateInput = {
      id: equipmentId,
      deletedOn: getNowIsoAtUtcWithLocalTimeZone(),
    };

    return editEquipmentMutation({ variables: { equipment: entry } });
  }

  return { createEquipment, editEquipment, deleteEquipment };
}
